export default function stepSetUnvalidating({ state }) {
  state.set('client.registrationStep.validating', false)
}



// WEBPACK FOOTER //
// ./src/modules/login/actions/stepSetUnvalidating.js